import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-toggle-select',
  templateUrl: './button-toggle-select.component.html',
  styleUrls: ['./button-toggle-select.component.scss'],
})
export class ButtonToggleSelect<T> {
  @Input() value?: T;
  @Input() options?: {
    value: T;
    label?: string;
  }[];

  @Output() readonly valueChange = new EventEmitter<T>();
}
